import { ReducersMapObject, combineReducers, Reducer } from 'redux'
import toggles from '../../feature-togglings/reducer'
import { locationReducer as geoLocation } from '../../data/location-detection/reducer'

import { AppState } from '../../store'
import { navigationReducer as navigation } from '../../data/navigation/navigation-open'
import { authenticationReducer } from '../../data/authentication/reducer'
import { metaReducer } from '../../meta/meta.redux'
import { withReduxStateSync } from 'redux-state-sync'
import { consentReducer } from '../../data/consent/consent.redux'
import { theWestLiveReducer } from '../../data/west-live/reducer'
import { renditionTypeReducer } from '../../data/render/render'

export function createRootReducer(): Reducer<AppState> {
    const reducers: ReducersMapObject<AppState> = {
        toggles,
        geoLocation,
        navigation,
        authentication: authenticationReducer,
        meta: metaReducer,
        consent: consentReducer,
        theWestLive: theWestLiveReducer,
        render: renditionTypeReducer,
    }

    return withReduxStateSync(combineReducers<AppState>(reducers)) as any
}
